<template>
  <div class="pass-container">
    <div class="tip">手机号不对？请返回个人中心-账号设置-修改手机号</div>

    <el-form ref="form" :model="form" label-width="80px" :rules="rules">
      <el-form-item label="手机号">
        <el-input v-model="phone" :disabled="true" class="phone"></el-input>
      </el-form-item>
      <el-form-item label="验证码" prop="captch">
        <el-input v-model="form.captch" class="captch"></el-input>
        <el-button
          type="primary"
          @click="getCode"
          v-if="!sendStatus"
          size="mini"
          style="width:100px;height:34px;"
        >获取验证码</el-button>
        <span v-else class="timer">重新获取({{countdown}}s)</span>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm('form')" v-trace-click="'n.3387.7193.0'">绑定</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: "Binding",
  data() {
    return {
      sendStatus: false,
      form: {
        captch: ""
      },
      countdown: "",
      rules: {
        captch: [{ required: true, message: "请输入验证码", trigger: "change" }]
      },
      timer: null
    };
  },
  computed: {
    phone() {
      return (
        this.$store.getters.userInfo.phone.slice(0, 3) +
        "****" +
        this.$store.getters.userInfo.phone.slice(7, 11)
      );
    }
  },
  methods: {
    getCode() {
      _api.personal.passportCode().then(res => {
        if (res.data) {
          this.sendStatus = true;
          this.countdown = 59;
          let timer = setInterval(() => {
            this.countdown--;
            if (this.countdown < 1) {
              clearInterval(timer._id);
              this.sendStatus = false;
            }
          }, 1000);
        } else {
          this.$message.error("获取验证码失败");
        }
      });
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$confirm("请阅读温馨提示，确认绑定？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }).then(() => {
            _api.personal.passportReg({ code: this.form.captch }).then(res => {
              if (res.error) {
                this.$message({
                  message: "验证码错误",
                  type: "error"
                });
              } else {
                this.$message({
                  message: "验证成功",
                  type: "success"
                });
                this.$emit("bindSuccess", "Success");
              }
            });
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.pass-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  .phone /deep/ {
    width: 296px;
    input {
      height: 34px !important;
      color: #999;
    }
  }
  .captch /deep/ {
    width: 181px;
    input {
      height: 34px !important;
    }
  }
  .tip {
    margin: 20px 0 30px;
    font-size: 14px;
  }
  button {
    width: 120px;
    height: 36px;
    font-size: 12px;
  }
  .timer {
    display: inline-block;
    width: 100px;
  }
}
</style>
<style lang="scss">
.pass-container {
  .el-input {
    width: 60%;
    padding-right: 10px;
  }
}
</style>
